import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import MiddleController from './cardsControllers/middleController';
import ImageAnnotationTool from './ImageAnnotationTool';
import VideoComponent from './videocomponent';
import RightBar from './RightBar';
import SideBar from '../sideBar';
import ThirdCard from './cardsControllers/thirdCard';
import { IS_ANNOTATION } from 'store/actions';

const VideoPage = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const targetRef = useRef(null);
  const [source, setSource] = useState('');
  const isAnnotation = useSelector((state) => state.cameraReducer.isAnnotation);
  const checkImage = useSelector((state) => state.cameraReducer.checkImage);

  useEffect(() => {
    if (checkImage) {
      dispatch({ type: IS_ANNOTATION, isAnnotation: true });
    }
    // eslint-disable-next-line
  }, [checkImage]);

  return (
    <div style={{ display: 'flex', backgroundColor: theme.palette.background.default }}>
      <SideBar selField="videos" />

      <div
        className="-m-6"
        style={{
          flexGrow: 1,
          marginLeft: '40px',
          width: '100%',
          minHeight: 'calc(100vh - 65px)',
          marginTop: '0',
          transition: 'margin-left 0.3s ease, width 0.3s ease'
        }}
      >
        <div className="block lg:hidden mb-2">
          <RightBar videoSource={setSource} position="top" />
        </div>

        <div className="flex flex-col lg:flex-row gap-2 w-full mb-3">
          <div className="lg:w-4/5 w-full">
            <div ref={targetRef} className="lg:w-full w-11/12 m-0 p-0">
              {isAnnotation ? <ImageAnnotationTool /> : <VideoComponent vdoSource={source} />}
            </div>
            <div className="flex flex-col lg:flex-row mt-2 gap-1 mb-1 text-white">
              <div className="lg:w-full w-11/12 h-[300px] bg-[#454545] rounded-lg">
                <MiddleController />
              </div>
              <div className="lg:w-full w-11/12 h-[300px] bg-[#454545] rounded-lg mt-2 lg:mt-0">
                <ThirdCard />
              </div>
            </div>
          </div>
          <div className="hidden lg:block lg:w-1/4 w-full mt-2 lg:mt-0">
            <RightBar videoSource={setSource} position="side" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPage;
